import React, { ReactElement, useEffect } from 'react';
import { useParams } from 'react-router';
import ClassType from '../../../model/pripomienka/ClassType';
import SaveAdminPripomienka from '../../../model/pripomienka/SaveAdminPripomienka';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';
import routes from '../../../routing/routes';
import { useUserContext } from '../../../context/UserContext';
import VyhodnotenieFormSection from './VyhodnotenieFormSection';
import PripomienkovatelFormSection from './PripomienkovatelFormSection';
import PripomienkaDetailRow from '../../PripomienkaDetail/component/PripomienkaDetailRow';
import UdajePripomienkyFormSection from './UdajePripomienkyFormSection';
import CreateAndUpdatePripomienkaAdminButtons from './CreateAndUpdatePripomienkaAdminButtons';
import { ClientStatus } from '../../../model/ClientStatus';
import { useActionContext } from '../../../context/ConfirmActionContext';

interface Props {
  classType: ClassType;
  onUpdateField: SafeParameterSetter<SaveAdminPripomienka>;
  onSubmit: () => void;
  submitStatus: ClientStatus;
  pripomienka: SaveAdminPripomienka,
  getFieldErrorMessage: (fieldName: string) => string,
}

const CreateAndUpdatePripomienkaAdminComponent = ({
  classType, onUpdateField, onSubmit, submitStatus, pripomienka, getFieldErrorMessage,
}: Props): ReactElement => {
  const {
    type, year, index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();

  const { legislationProcess } = useUserContext();
  const { cancelAction, visible } = useActionContext();

  useEffect(() => {
    if (visible === true) {
      cancelAction();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pripomienka]);

  const getBackUrl = (): string => (classType === ClassType.HROMADNA_PRIPOMIENKA
    ? routes.hromadnePripomienky.list.withParams(type, year, index)
    : routes.pripomienky.list.withParams(type, year, index));

  return (
    <>
      <PripomienkaDetailRow header="Názov LP:" data={legislationProcess?.nazovPredpisu} />
      <PripomienkovatelFormSection
        onUpdateField={onUpdateField}
        pripomienka={pripomienka}
      />
      <UdajePripomienkyFormSection
        classType={classType}
        getFieldErrorMessage={getFieldErrorMessage}
        onUpdateField={onUpdateField}
        pripomienka={pripomienka}
      />
      <VyhodnotenieFormSection
        onUpdateField={onUpdateField}
        pripomienka={pripomienka}
        getFieldErrorMessage={getFieldErrorMessage}
      />
      <CreateAndUpdatePripomienkaAdminButtons
        getBackUrl={getBackUrl}
        loading={submitStatus.loading}
        onSubmit={onSubmit}
      />
    </>
  );
};
export default CreateAndUpdatePripomienkaAdminComponent;
